import { Control, FieldErrors, useFieldArray, UseFormRegister } from 'react-hook-form';
import { Stack } from '@mui/material';

import { TextFieldWithHelperSpace } from '@components/TextFieldWithHelperSpace';

import { generalPredefinedPromptsTexts } from '../../../constants';
import { FormValues } from '../GeneralPredefinedPrompts';

import { AddButton } from './AddButton';
import { PromptSectionTitle } from './PromptSectionTitle';
interface PromptSectionProps {
    errors: FieldErrors<FormValues>;
    groupIndex: number;
    register: UseFormRegister<FormValues>;
    isSending: boolean;
    groupId?: string;
    control: Control<FormValues>;
}

export const PromptSection = ({
    errors,
    groupIndex,
    register,
    isSending,
    groupId,
    control,
}: PromptSectionProps) => {
    const { fields, append, remove } = useFieldArray({
        control,
        name: `groups.${groupIndex}.prompts`,
    });
    return (
        <Stack gap={2}>
            {fields.map(({ promptId, id: fieldId }, promptIndex) => {
                const labelError = errors.groups?.[groupIndex]?.prompts?.[promptIndex]?.label;
                const textError = errors.groups?.[groupIndex]?.prompts?.[promptIndex]?.text;

                return (
                    <Stack key={fieldId} gap={1}>
                        <PromptSectionTitle
                            promptId={promptId}
                            groupId={groupId}
                            promptIndex={promptIndex}
                            deleteDynamicField={remove}
                        />
                        <TextFieldWithHelperSpace
                            label={generalPredefinedPromptsTexts.labelInputTitle}
                            disabled={isSending}
                            {...register(`groups.${groupIndex}.prompts.${promptIndex}.label`)}
                            fieldError={labelError}
                            size='small'
                        />
                        <TextFieldWithHelperSpace
                            label={generalPredefinedPromptsTexts.textInputTitle}
                            disabled={isSending}
                            multiline
                            minRows={2}
                            {...register(`groups.${groupIndex}.prompts.${promptIndex}.text`)}
                            fieldError={textError}
                        />
                    </Stack>
                );
            })}
            <AddButton onAdd={() => append({ label: '', text: '' })} />
        </Stack>
    );
};
